const ExportDefault = (props) => {
  const { component } = props;
  const envHelper = component.getHelpers("env");
  const urlHelper = component.getHelpers("url");
  const account = envHelper.getDefaultAccount();
  const repository = envHelper.getDefaultRepository();
  const closed = component.getHelpers("value").getValue("closed");

  return (
    <div className="container" style={{ maxWidth: 1040, margin: "0 auto" }}>
      <div className="desktop-banner">
        <a href="/bzr">
          <img
            src={urlHelper.createAccountImageUrl(
              account,
              repository,
              "item",
              "gallery",
              "default",
              "slider_bzr",
            )}
            alt="bazaar desktop"
          />
        </a>
      </div>
      <div className="mobile-banner">
        <a href="/bzr">
          <img
            src={urlHelper.createAccountImageUrl(
              account,
              repository,
              "item",
              "gallery",
              "default",
              "slider_bzr_mobile",
            )}
            alt="bazaar mobile"
          />
        </a>
      </div>
      {closed === "true" &&
        component.trans("header-message") !== "header message" && (
          <div
            style={{
              textAlign: "center",
              fontSize: "22px",
              color: "#000",
            }}
            className="mt-3 mt-lg-5"
          >
            <div className="mb-2">{component.trans("header-message")}</div>
          </div>
        )}
    </div>
  );
};

export default ExportDefault;
